import EmblaCarousel from "embla-carousel";

export const emblaSliders = () => {
    document.querySelectorAll('.embla').forEach((emblaNode) => {
        const viewport = emblaNode.querySelector('.embla__viewport');
        if (!viewport) return;

        const prevBtn = emblaNode.querySelector('.embla__button--prev');
        const nextBtn = emblaNode.querySelector('.embla__button--next');

        const embla = EmblaCarousel(viewport, {
            loop: false,
            align: 'start',
            slidesToScroll: 1,
        });

        const updateButtons = () => {
            if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
            if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
        };

        if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
        if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

        embla.on('select', updateButtons);
        embla.on('init', updateButtons);
        embla.on('reInit', updateButtons);
        updateButtons();
    });
}
